exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menu-header{flex-direction:row;align-content:center;height:70px;background-color:#fff;border-bottom:1px solid #e7e7e7;margin-bottom:20px}.menu-header .country-select{max-width:200px}.menu-header .menu-items{width:300px}.menu-header .menu-items a{justify-content:center}.menu-header .menu-items a:hover{background:#eb102f}.menu-header .menu-items a:hover span{color:#fff!important}.v-toolbar__content{max-width:1140px;width:100%}.main-logo{max-height:50px;max-width:125px}", ""]);

// exports
